import { AsyncPipe } from '@angular/common';

import { Component, ChangeDetectionStrategy, Type } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';

import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyModule,
} from '@ngx-formly/core';

import {
  FormlyFieldSelectProps,
  FormlySelectModule,
} from '@ngx-formly/core/select';

import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { Select, SelectModule } from 'primeng/select';
import { LanguagePipe } from '../../pipes';
import { TranslocoModule } from '@jsverse/transloco';
import { multiLangFilterBy } from '../../utils/multilang-filter.util';

interface SelectProps extends FormlyFieldProps, FormlyFieldSelectProps {
  appendTo?: Select['appendTo'];
  filter?: boolean;
  filterBy?: string;
  multiLang?: boolean;
  translate?: boolean;
}

export interface FormlySelectFieldConfig
  extends FormlyFieldConfig<SelectProps> {
  type: 'multiselect' | Type<TypeSelect>;
}

@Component({
  selector: 'lib-type-select',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    SelectModule,
    FormlyModule,
    FormlySelectModule,
    AsyncPipe,
    LanguagePipe,
    TranslocoModule,
  ],
  template: `
    <p-select
      [placeholder]="props.placeholder | transloco"
      [options]="(props.options | formlySelectOptions: field | async) || []"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [showClear]="!props.required"
      [appendTo]="props.appendTo"
      [filter]="props.filter"
      [filterBy]="resolveFilterBy()"
      [optionLabel]="'label'"
      [optionValue]="'value'"
      [styleClass]="'wrap-select min-w-[180px]'"
      (onChange)="props.change && props.change(field, $event)"
      fluid
    >
      @if (props.multiLang) {
        <ng-template #selectedItem let-selectedOption>
          <span>{{ selectedOption.label | languagePipe | async }}</span>
        </ng-template>
        <ng-template let-item #item>
          <span style="white-space: normal;">{{
            item.label | languagePipe | async
          }}</span>
        </ng-template>
      }
      @if (props.translate) {
        <ng-template #selectedItem let-selectedOption>
          <span>{{ selectedOption.label | transloco }}</span>
        </ng-template>
        <ng-template let-item #item>
          <span style="white-space: normal;">{{ item.label | transloco }}</span>
        </ng-template>
      }
    </p-select>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TypeSelect extends FieldType<FieldTypeConfig<SelectProps>> {
  resolveFilterBy(): string {
    if (this.props.filterBy) {
      return this.props.filterBy;
    }
    if (this.props.multiLang) {
      return multiLangFilterBy('label');
    }
    return 'label';
  }
}
